import {
  Box,
  ColorSwatch,
  Flex,
  Group,
  Paper,
  Stack,
  Text,
} from "@mantine/core";
import {
  TicketUpdate,
  useUpdatesForUser,
} from "../../../../../../../api/tickets/useUpdatesForUser";
import classes from "./styles.module.scss";
import { Link } from "@tanstack/react-router";
import { IconInfoCircle } from "@tabler/icons-react";

function TicketsPreview() {
  const { data } = useUpdatesForUser();
  if (!data?.length) return null;
  return (
    <Stack gap="sm">
      <Box pt="xs" px="xs">
        <Group c="bluegray.4" gap="xs">
          <IconInfoCircle size={16} />
          <Text size="sm">Det finns nya svar i dina ärenden</Text>
        </Group>
      </Box>
      <Stack gap={0}>
        {data.map((ticket) => (
          <TicketPreview key={ticket.MessageID} ticket={ticket} />
        ))}
      </Stack>
    </Stack>
  );
}

function TicketPreview({ ticket }: { ticket: TicketUpdate }) {
  const trimmedBody = ticket.Body.trim();
  return (
    <Link to="/admin/tickets/$id" params={{ id: ticket.TicketID.toString() }}>
      <Paper p="xs" className={classes.ticket}>
        <Flex align="center" gap="xs" justify="space-between">
          <Stack gap={4}>
            <Text size="sm">{ticket.Sender}</Text>
            <Text size="sm" fw="bold">
              {trimmedBody}
              {trimmedBody[trimmedBody.length - 1] !== "." && "…"}
            </Text>
          </Stack>
          <ColorSwatch color="var(--mantine-color-blue-5)" size={8} />
        </Flex>
      </Paper>
    </Link>
  );
}

export default TicketsPreview;
